import { PermissionTableRowType } from '../../../../../../types/common/PermissionType';
import { PERMISSION_ACTIONS, PERMISSION_SUBJECTS } from '../../../../../../constants/service/common/userPermissions';
/*
주문 생성 : create
주문 관리 리스트 조회 : readList
주문 상태 변경 : update
엑셀다운로드 : downloadExcel
*/
export const MULTI_CHANNEL_MENU: PermissionTableRowType = {
  name: '멀티채널',
  key: 'MULTI_CHANNEL_MANAGE',
  subRows: [
    {
      name: '멀티채널 주문 관리',
      key: PERMISSION_SUBJECTS.MULTI_CHANNEL_ORDER_ITEM,
      permissions: [
        PERMISSION_ACTIONS.CREATE,
        PERMISSION_ACTIONS.READLIST,
        PERMISSION_ACTIONS.UPDATE,
        PERMISSION_ACTIONS.DOWNLOAD_EXCEL,
      ],
      subRows: [
        {
          name: '멀티채널 주문 생성',
          key: PERMISSION_SUBJECTS.MULTI_CHANNEL_ORDER_ITEM,
          permissions: [PERMISSION_ACTIONS.CREATE],
        },
        {
          name: '리스트 조회',
          key: PERMISSION_SUBJECTS.MULTI_CHANNEL_ORDER_ITEM,
          permissions: [PERMISSION_ACTIONS.READLIST],
        },
        {
          name: '멀티채널 주문 상태 변경',
          key: PERMISSION_SUBJECTS.MULTI_CHANNEL_ORDER_ITEM,
          permissions: [PERMISSION_ACTIONS.UPDATE],
        },
        {
          name: '멀티채널 주문 엑셀 다운로드',
          key: PERMISSION_SUBJECTS.MULTI_CHANNEL_ORDER_ITEM,
          permissions: [PERMISSION_ACTIONS.DOWNLOAD_EXCEL],
        },
      ],
    },
  ],
};
